﻿import { DomainEventHandler } from '../events/DomainEventHandler';
import { IGoogleEvent } from '../events/DomainEvent';
import { EventType } from '../events/DomainEvent';
import * as DomainEventRegistry from '../events/DomainEventRegistry';

export class PromoBannerClickEvent implements IGoogleEvent {
    name: string = "PromoBannerClickEvent";
    category: string = "banner";
    label: string = "Promo Banner Click";
    type: EventType = EventType.Click;
}

@DomainEventRegistry.DomainEventRegistry.register
class PromoBannerClickEventHandler extends DomainEventHandler {

    domainEventName: string = "PromoBannerClickEvent";

    handleDomainEvent<PromoBannerClickEvent>(ev: CustomEvent, args: PromoBannerClickEvent): void {

    }
}